module.exports = "<nominas-nomina-colaboradores-lista-noremunerados-item\r\n    ng-repeat=\"item in $ctrl.resultados track by item.empleado\"\r\n    data=\"item\"></nominas-nomina-colaboradores-lista-noremunerados-item>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/nomina/components/colaboradores/lista/noremunerados/template.html
// module id = 1156
// module chunks = 0